import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=6f3b5763&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=6f3b5763&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3b5763",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f3b5763')) {
      api.createRecord('6f3b5763', component.options)
    } else {
      api.reload('6f3b5763', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=6f3b5763&scoped=true&", function () {
      api.rerender('6f3b5763', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2k6AepnnsWrY6/JS/comp/SearchFilterTokens.vue"
export default component.exports